import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader, SearchBar } from "../../../components";
import { postRequest } from "../../../constants/api";
import { formatDate } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import { Box, Alert, Button, Snackbar } from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const UbahMisalLelangKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idMisalLelangKelompok } = useParams();
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [no, setNo] = useState("");
  const [misalLelang, setMisalLelang] = useState("");

  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    getMisalLelangKelompokById();
  }, []);

  const getMisalLelangKelompokById = async () => {
    setLoading(true);
    const pickedMisalLelangKelompok = await postRequest(
      `/misalLelangKelompoks/${idMisalLelangKelompok}`,
      {},
      navigate,
      dispatch,
    );
    setNo(pickedMisalLelangKelompok.data.no);
    setMisalLelang(pickedMisalLelangKelompok.data.misalLelang);
    setLoading(false);
  };

  const updateMisalLelangKelompok = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (form.checkValidity() && no.length !== 0) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/updateMisalLelangKelompok/${idMisalLelangKelompok}`,
          {
            kelompokId: id,
            misalLelang,
          },
          navigate,
          dispatch,
        );
        setLoading(false);
        navigate(`/daftarKelompok/kelompok/${id}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Detail Misal Lelang Kelompok</h5>
      <hr />
      <Card>
        <Card.Header>Detail Misal Lelang Kelompok</Card.Header>
        <Card.Body>
          <Form
            noValidate
            validated={validated}
            onSubmit={updateMisalLelangKelompok}
          >
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control disabled value={no} />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Misal Lelang <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <NumericFormat
                      required
                      value={misalLelang}
                      decimalSeparator={","}
                      thousandSeparator={"."}
                      customInput={Form.Control}
                      onValueChange={(values) => {
                        setMisalLelang(
                          values.formattedValue
                            .split(".")
                            .join("")
                            .replace(/,/g, ""),
                        );
                      }}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() =>
                  navigate(
                    `/daftarKelompok/kelompok/${id}/misalLelangKelompok/${idMisalLelangKelompok}`,
                  )
                }
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahMisalLelangKelompok;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};
